module.exports = __webpack_public_path__ + "static/media/bond.d07dde44.svg";